module.exports = __webpack_public_path__ + "static/img/IMG_20240326_185938.26822d61.jpg";